var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_241623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7695 0H1.72656C0.910156 0 0.25 0.644531 0.25 1.44141V18.5547C0.25 19.3516 0.910156 20 1.72656 20H18.7695C19.5859 20 20.25 19.3516 20.25 18.5586V1.44141C20.25 0.644531 19.5859 0 18.7695 0ZM6.18359 17.043H3.21484V7.49609H6.18359V17.043ZM4.69922 6.19531C3.74609 6.19531 2.97656 5.42578 2.97656 4.47656C2.97656 3.52734 3.74609 2.75781 4.69922 2.75781C5.64844 2.75781 6.41797 3.52734 6.41797 4.47656C6.41797 5.42188 5.64844 6.19531 4.69922 6.19531ZM17.293 17.043H14.3281V12.4023C14.3281 11.2969 14.3086 9.87109 12.7852 9.87109C11.2422 9.87109 11.0078 11.0781 11.0078 12.3242V17.043H8.04688V7.49609H10.8906V8.80078H10.9297C11.3242 8.05078 12.293 7.25781 13.7344 7.25781C16.7383 7.25781 17.293 9.23438 17.293 11.8047V17.043Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_241623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.79a263cd2504b1d0c0801e127e9f8f7d.svg";
export { ForwardRef as ReactComponent };